import { useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import {
  currentChartSettingsSelector,
  chartSettingsSnapshotSelector,
} from '../redux/selectors/analyses';
import { useAppSelector } from '../redux/hooks';
import { assertNotNil } from './types';
import { useChartContext } from '../components/Chart/ChartContext';

const useCompareChartSettings = (analysisId: string): boolean => {
  const {
    metadata: { hasUpdateDisplayOrDescription },
  } = useChartContext();

  const chartSettingsSnapshotMemoizedSelector = useMemo(
    chartSettingsSnapshotSelector,
    [],
  );
  const chartSettingsSnapshot = useAppSelector((state) =>
    chartSettingsSnapshotMemoizedSelector(state, analysisId),
  );

  const currentChartSettingsMemoizedSelector = useMemo(
    currentChartSettingsSelector,
    [],
  );
  const currentChartSettings = useAppSelector((state) =>
    currentChartSettingsMemoizedSelector(state, analysisId),
  );
  assertNotNil(currentChartSettings);

  if (hasUpdateDisplayOrDescription) {
    return true;
  }

  return !isEqual(chartSettingsSnapshot, currentChartSettings);
};

export default useCompareChartSettings;
